import { call, put, takeLatest, select } from 'redux-saga/effects';
import { submitTitleSuccess, submitTitleFailed, setOpenSalvageAlert, setMoveToNextTab } from './action';
import { Api } from './api';
import { DOWNLOAD_TITLE_OUTPUT, DOWNLOAD_TITLE_OUTPUT_FAILED, DOWNLOAD_TITLE_OUTPUT_SUCCESS, SUBMIT_TITLE } from './types';

function* submitTitle(action) {
  try {
    const response = yield call(Api.submitTitle, action.payload);

    if (response?.status === 200) {
      const { jsi_info } = response.data;
      const salvage = jsi_info?.some(hash => hash.disposition_text === 'SALVAGE')
      yield put(submitTitleSuccess(response.data));
      if (action.navigate){
        action.navigate('titleOutput');
        return;
      }
      if (salvage) {
        yield put(setOpenSalvageAlert(true));
        return;
      }

      if (action.requiresMoveToNextTab) {
        yield put(setMoveToNextTab(true));
      }
    } else {
      yield put(submitTitleFailed(response?.data?.error || response?.data?.message || 'Submission failed'));
    }
  } catch (error) {
    yield put(submitTitleFailed(error.message || 'Unexpected error Occurred, try Again'));
  }
}

function* downloadTitleOutput() {
  const state = yield select();
  const titleCheckResponse = state.titleCheck.titleCheckResponse;

  try {
    const response = yield call(Api.downloadTitleOutput, titleCheckResponse);

    if (response?.status === 200) {
      yield put({
        type: DOWNLOAD_TITLE_OUTPUT_SUCCESS,
      })
    }
    else {
      yield put({
        type: DOWNLOAD_TITLE_OUTPUT_FAILED,
      })
    }
  } catch (error) {
    yield put({
      type: DOWNLOAD_TITLE_OUTPUT_FAILED,
    })
  }
}

function* titleCheckSaga() {
  yield takeLatest(SUBMIT_TITLE, submitTitle);
  yield takeLatest(DOWNLOAD_TITLE_OUTPUT, downloadTitleOutput);
}

export default titleCheckSaga;
